import { ValidatedCartBreakdown } from '@water-web/types';

/**
 * It's possible not to pay with card if a gift card covers total; but we need to differentiate
 * when a gift card covers everything, vs. when the total sum of order is 0 (free services) and no GC.
 */
export const getIsCoveredByGiftCardFromCartBreakdown = (breakdown: ValidatedCartBreakdown): boolean => {
  return !!breakdown.discountAmount && breakdown.outstandingChargeAmount === 0;
};
